import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NavbarService } from '../../navbar.service';
import { CandidatosApiService } from 'src/app/core/services/candidatos-api.service';
import { AuthApiService } from 'src/app/core/services/auth-api-service';

@Component({
  selector: 'app-navbar-top',
  templateUrl: './navbar-top.component.html',
  styleUrls: ['./navbar-top.component.scss'],
  standalone: false
})
export class NavbarTopComponent implements OnInit {
  isVisible = true;
  isLoggedIn$ = this.authApiService.isLoggedIn();
  user$ = this.authApiService.getUser();
  logoImageUrl: string = ''; // URL dinámica del logo

  constructor(private authApiService: AuthApiService,
    private translate: TranslateService, private navbarService: NavbarService) {
    this.navbarService.navbarVisibility$.subscribe(visible => {
      // this.isVisible = visible;
    });
    this.translate.setDefaultLang('esmx'); // Idioma por defecto
  }

  logout() {
    this.authApiService.logout();
  }
  ngOnInit(): void {
    this.setLogoImageByDomain();
  }

  setLogoImageByDomain(): void {
    const hostname = window.location.hostname;
    
    // Si es manpowergroup.com.mx, usar el logo actual
    if (hostname.includes('manpowergroup.com.mx')) {
      this.logoImageUrl = '/assets/img/logo-manpowergroup.png';
    } else {
      // Default para manpower.com.mx u otros dominios
      this.logoImageUrl = '/assets/img/logo-manpower.png';
    }
  }

}
